// extracted by mini-css-extract-plugin
export default {"companyContainer":"ZJ-z","companyImage":"_J-z","container":"aK-z","heading":"bK-z","darkText":"cK-z","smallHeading":"dK-z","darkBackground":"eK-z","whiteBackground":"fK-z"};